/* jscs:disable disallowArrayDestructuringReturn */
import WebMercatorViewport from 'viewport-mercator-project';

const getViewport = (vw, markers) => {
  const lats = markers.map(marker => marker.lat);
  const lngs = markers.map(marker => marker.lng);

  const ne = { lat: Math.max(...lats), lng: Math.max(...lngs) };
  const sw = { lat: Math.min(...lats), lng: Math.min(...lngs) };

  // if the coordinates are somehow equal to each other, fitBounds will return bad values
  if (ne.lat === sw.lat || ne.lng === sw.lng) {
    sw.lat -= 0.0000001;
    sw.lng -= 0.0000001;
  }

  const viewport = new WebMercatorViewport(vw);
  const { longitude, latitude, zoom } = viewport.fitBounds([[sw.lng, sw.lat], [ne.lng, ne.lat]], {
    padding: 40,
  });

  return {
    ...viewport,
    longitude,
    latitude,
    zoom,
  };
};

export { getViewport };
